import http from 'hub-http/clients/apiClient';
const ACCESS_GROUPS_URI = 'contentmembership/access-groups';
export default class AccessGroupsAPI {
  static getAccessGroups(accessGroupIds) {
    const query = accessGroupIds ? {
      accessGroupIds
    } : {};
    return http.get(`${ACCESS_GROUPS_URI}/list-all`, {
      query,
      timeout: 40000
    });
  }
  static getAccessGroupsPortalUsage() {
    return http.get(`${ACCESS_GROUPS_URI}/available`);
  }
}